function BlogDateInline({ post }) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    return (
        <span className="text-xs">
            {new Date(post.date)
                .toLocaleDateString('en-US', options)
                .toUpperCase()}
        </span>
    )
}

export default BlogDateInline
